import request from '@/utils/request'


// 查询球场基础设施列表
export function listInfrastructure(query) {
  return request({
    url: '/golf/golf-infrastructure/list',
    method: 'get',
    params: query
  })
}

// 查询球场基础设施分页
export function pageInfrastructure(query) {
  return request({
    url: '/golf/golf-infrastructure/page',
    method: 'get',
    params: query
  })
}

// 查询球场基础设施详细
export function getInfrastructure(data) {
  return request({
    url: '/golf/golf-infrastructure/detail',
    method: 'get',
    params: data
  })
}

// 新增球场基础设施
export function addInfrastructure(data) {
  return request({
    url: '/golf/golf-infrastructure/add',
    method: 'post',
    data: data
  })
}

// 修改球场基础设施
export function updateInfrastructure(data) {
  return request({
    url: '/golf/golf-infrastructure/edit',
    method: 'post',
    data: data
  })
}

// 删除球场基础设施
export function delInfrastructure(data) {
  return request({
    url: '/golf/golf-infrastructure/delete',
    method: 'post',
    data: data
  })
}
